import { DatePicker, Table, TableColumn, Select, Option, Checkbox, Popover } from 'element-ui';
import { Switch as LSwitch } from '@/components/index';
import { Pagination as LPagination } from '@/components/index';
import ResourceSvc from '@/services/resource.svc.js';
const svc = new ResourceSvc();
import { EventBus } from '@/services/Event.js';

export default {
    name: 'AdminPaymentsTab',
    components: {
        LPagination, [Checkbox.name]: Checkbox, [Select.name]: Select, [Option.name]: Option, [Table.name]: Table,
        [TableColumn.name]: TableColumn, [DatePicker.name]: DatePicker, LSwitch, [Popover.name]: Popover
    },
    data() {
        return {
            pagination: {
                perPageOptions: [5, 10, 25, 50],
                currentPage: 1, perPage: 5, total: 0, from: 0, to: 0
            },
            tableColumns: [
                { prop: 'paymentDateString', label: 'Date', minWidth: 64 },
                { prop: 'userIdString', label: 'TI Member', minWidth: 79 }
            ],
            tableData: [], //{ paymentData: '', description: '', totalTransactionPrice: '', discount: '', 
            //alreadyRefundedAmountForTransaction: '', paymentPrice: '', alreadyRefundedAmountForPayment: '', availableForRefund: '', priceDetails: {}}
            pickerOptionsFrom: {
                shortcuts: [{
                    text: 'Now',
                    onClick(picker) { picker.$emit('pick', new Date()); }
                },
                {
                    text: 'Week ago',
                    onClick(picker) { const date = new Date(); date.setTime(date.getTime() - 3600 * 1000 * 24 * 7); picker.$emit('pick', date); }
                },
                {
                    text: 'Month ago',
                    onClick(picker) { const date = new Date(); date.setTime(date.getTime() - 3600 * 1000 * 24 * 30); picker.$emit('pick', date); }
                }],
            },
            pickerOptionsTo: {
                shortcuts: [
                    {
                        text: 'Now',
                        onClick(picker) { picker.$emit('pick', new Date()); }
                    },
                    {
                        text: 'In one week',
                        onClick(picker) { const date = new Date(); date.setTime(date.getTime() + 3600 * 1000 * 24 * 7); picker.$emit('pick', date); }
                    },
                    {
                        text: 'In one month',
                        onClick(picker) { const date = new Date(); date.setTime(date.getTime() + 3600 * 1000 * 24 * 30); picker.$emit('pick', date); }
                    }
                ]
            },

            params: { purchaseType: '', itemId: 0, dateFrom: new Date(Date.now() - 3600 * 1000 * 24), dateTo: new Date(), searchType: '', searchQuery: '', itemYear: null },

            searchQuery: '',
            savedParams: null,
            getAllPayments: false,
            itemType: '',
            paymentTypes: [],
            searchTypes: [],
            items: [],
            isLoading: false,
            isProcessRefundMode: false,
            skipPaymentModule: false,
            processRefundAmount: 0,
            processRefundReason: '',
            refundPolicy: '',
            refundPolicyLog: [],
            isRefundClicked: false,
            availableForRefund: 0,
            processRefundItemName: '',
            isProcessRefundStarted: false,
            isProcessCancelStarted: false,
            isProcessCancelConfirmed: false,
            isIncludeFreeRaces: false,
            cancelProcessStatusName: '',
            processCancelErrors: [],
            processRefundsErrors: [],
            selectedPaymentListIDs: [],
            yearSelect: [],
            currentYear: new Date().getFullYear(),
            isAnyPaymentForNextYear: false,

            purchaseRaceType: 4,

            processRefundsPayments: [{
                alreadyRefundedAmountForPayment: 0,
                alreadyRefundedAmountForTransaction: 0,
                availableForRefund: 0,
                paymentPrice: 0,
                totalTransactionPrice: 0,
                discount: 0,
                paymentItem: {
                    itemId: 0, itemName: '', itemType: 0, refundPolicy: '', refundPolicyLog: []
                },
                paymentMainData: {
                    paymentDateString: '', transactionCode: '', purchaseTypeString: '', description: ''
                }
            }]
        };
    },
    methods: {
        isTransferred(item) {
            if (item.transferId && item.purchaseType == 4) {
                return true;
            } else return false;
        },
        addCheckboxToHeader(h, { column, $index }) {
            let self = this
            if (!self.params.itemId || !self.tableData || !self.tableData.length) {
                return "";
            }

            let allIds = self.tableData
                .filter(item => { return item.isActionAllowed; })
                .map(x => x.tiPaymentId);

            if (!allIds || !allIds.length) {
                return "";
            }

            let result = h('el-checkbox', {
                props: { size: 'small' },
                on: {
                    change(state, data) {
                        self.tableData.forEach(x => { x.isChoosed = state; });
                        if (state) {
                            self.selectedPaymentListIDs = allIds;
                        }
                        else {
                            self.selectedPaymentListIDs = [];
                        }
                    }
                }
            })
            var data = h('div', { style: '' }, [h('', null, column.label), result]);
            return data;
        },
        changeSelectedListIds(paymentId) {
            var self = this;
            if (!self.params.itemId) {
                var index = self.selectedPaymentListIDs.indexOf(paymentId);
                self.selectedPaymentListIDs = [];
                if (index > -1) {
                    self.selectedPaymentListIDs.splice(index, 1);
                }
                else {
                    self.selectedPaymentListIDs.push(paymentId);
                    self.tableData.forEach(item => {
                        item.isChoosed = item.tiPaymentId == paymentId;
                    });
                }
            }
            else {
                var index = self.selectedPaymentListIDs.indexOf(paymentId);
                if (index > -1) {
                    self.selectedPaymentListIDs.splice(index, 1);
                }
                else {
                    self.selectedPaymentListIDs.push(paymentId);
                }
            }
            self.cancelProcessStatusName = '';
            if (self.selectedPaymentListIDs.length) {
                var itemsConfirmed = self.tableData
                    .filter(item => {
                        return item.status == 3 && self.selectedPaymentListIDs.indexOf(item.tiPaymentId) > -1;//confirmed
                    });

                if (itemsConfirmed.length == self.selectedPaymentListIDs.length) {
                    self.cancelProcessStatusName = 'Cancel';
                }
                else if (!itemsConfirmed.length) {
                    self.cancelProcessStatusName = 'Undo Cancel';
                }
            }
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.status == 3) {
                return 'row-confirmed';
            }
            else if (row.status == 5) {
                return 'row-cancelled';
            }
            else {
                return '';
            }
        },
        formatDate(d) {
            var day = d.getDate();
            if ((day + '').length == 1) day = '0' + day;

            var month = d.getMonth() + 1;
            if ((month + '').length == 1) month = '0' + month;

            var hours = d.getHours();
            if ((hours + '').length == 1) hours = '0' + hours;

            var minutes = d.getMinutes();
            if ((minutes + '').length == 1) minutes = '0' + minutes;

            var seconds = d.getSeconds();
            if ((seconds + '').length == 1) seconds = '0' + seconds;

            var pretty_date = [d.getFullYear(), month, day].join('-');
            var pretty_time = [hours, minutes, seconds].join(':');

            return pretty_date + 'T' + pretty_time + '.000Z';
        },
        getParams() {
            if (this.savedParams && JSON.parse(this.savedParams).purchaseType != this.params.purchaseType) {
                this.params.itemId = 0;
                this.params.itemYear = null;
                this.isIncludeFreeRaces = false;
            }

            var searchType = this.params.searchType;
            if (!searchType) searchType = 0;

            var params = {
                purchaseType: this.params.purchaseType,
                itemId: this.params.itemId,
                itemYear: this.params.itemYear,
                dateFrom: this.params.dateFrom,
                dateTo: this.params.dateTo,
                take: this.pagination.currentPage * this.pagination.perPage,
                skip: (this.pagination.currentPage - 1) * this.pagination.perPage,
                searchQuery: this.params.searchQuery,
                searchType: searchType,
                isIncludeFreeRaces: this.isIncludeFreeRaces
            };
            return params;
        },
        yearChanged() {
            this.params.itemId = 0;
            this.isIncludeFreeRaces = false;
        },
        changeDate(from) {
            this.getAllPayments = false;
            var oldParamsDateFrom = JSON.parse(this.savedParams).dateFrom;
            var oldParamsDateTo = JSON.parse(this.savedParams).dateTo;

            if (oldParamsDateFrom && this.params.dateFrom && this.params.dateFrom.getFullYear() != new Date(oldParamsDateFrom).getFullYear()) {
                this.params.itemId = 0;
            }
            else if (oldParamsDateTo && this.params.dateTo && this.params.dateTo.getFullYear() != new Date(oldParamsDateTo).getFullYear()) {
                this.params.itemId = 0;
            }

            this.queriedData();
        },
        queriedData() {
            var self = this;
            var params = this.getParams();
            if (JSON.stringify(params) != this.savedParams) {
                self.savedParams = JSON.stringify(params);
                return self.loadData(params);
            }
            return self.tableData;
        },
        getFrom() {
            if (!this.pagination.total) {
                return 0
            }
            else {
                return (this.pagination.currentPage - 1) * this.pagination.perPage + 1;
            }
        },
        getTo() {
            if (!this.pagination.total) {
                return 0;
            }
            else
                if ((this.pagination.currentPage) * this.pagination.perPage > this.pagination.total) {
                    return this.pagination.total;
                }
                else {
                    return (this.pagination.currentPage) * this.pagination.perPage;
                }
        },
        loadData(params) {
            var self = this;
            if (params.dateFrom) {
                params.dateFrom = self.formatDate(params.dateFrom);
            }

            if (params.dateTo) {
                params.dateTo = self.formatDate(params.dateTo);
            }

            if (params.itemId) {
                self.tableData = [];
            }

            if (params.purchaseType != this.purchaseRaceType) {
                params.isIncludeFreeRaces = false;
                this.isIncludeFreeRaces = false;
            }

            svc.getPayments(params)
                .then((resp) => {
                    var allData = resp.body;
                    if (!allData) return [];

                    self.tableData = allData.payments;
                    self.currentYear = allData.currentYear;
                    self.isAnyPaymentForNextYear = allData.isAnyPaymentForNextYear;
                    self.updateYearSelect();

                    self.pagination.total = allData.total;
                    self.pagination.from = self.getFrom();
                    self.pagination.to = self.getTo();

                    if (!self.paymentTypes.length) {
                        self.paymentTypes = allData.paymentTypes;
                    }

                    if (!self.searchTypes.length) {
                        self.searchTypes = allData.searchTypes;
                    }

                    if (!allData.selectedItem) {
                        self.items = allData.items;
                    }
                    else {
                        self.params.itemId = allData.selectedItem;
                    }

                    self.itemType = allData.itemTypeString;
                    self.selectedPaymentListIDs = [];
                },
                    () => {
                        return [];
                    });
        },
        exportData() {
            var self = this;

            if (!self.tableData || !self.tableData.length) {
                self.$notify({ message: 'There is no payments to export', type: 'warning' });
                return;
            }

            var params = self.getParams();
            params.skip = 0;
            params.take = 10000;

            if (params.dateFrom) {
                params.dateFrom = self.formatDate(params.dateFrom);
            }
            if (params.dateTo) {
                params.dateTo = self.formatDate(params.dateTo);
            }

            self.isLoading = true;

            svc.getPayments(params)
                .then((resp) => {
                    self.isLoading = false;

                    var allData = resp.body;
                    if (!allData || !allData.payments && !allData.payments.length) {
                        self.$notify({ message: 'Payments records not received, something went wrong, please contact with dev team', type: 'danger' });
                        return;
                    }

                    self.exportToExcel(allData.payments);
                    self.$notify({ message: 'Payments successfully saved', type: 'success' });
                },
                    () => {
                        self.$notify({ message: 'Something went wrong, please contact with dev team: ' + resp.body, timeout: 60000, type: 'danger' });
                        self.isLoading = false;
                    });
        },
        exportToExcel(data) {

            function freeRacesChecker(item) {
                if (item.priceDetails === null) {
                    item.priceDetails = [];
                }
            }

            if (data && data.length) {
                var sheetData = [];
                data.forEach(function (item) {
                    freeRacesChecker(item);
                    sheetData.push({
                        "Paid By TI Number": item.paydByTiId,
                        "Paid For TI Number": item.userTiId,
                        "Paid For First Name": item.firstName,
                        "Paid For Last Name": item.lastName,
                        "Paid By Email": item.email,
                        "Purchase Type": item.purchaseTypeString,
                        "Club": item.clubName,
                        "Race": [item.raceName, item.raceDateString].join(' '),
                        "Race Date": item.raceDateString,
                        "Gross Price": item.priceBeforeDiscount,
                        "Discount": item.priceDetails.discount,
                        "Net Price": item.priceAfterDiscount,
                        "Refunded": item.totalRefunded,
                        "Description": item.description,
                        "Transaction Date": item.paymentDateString,
                        "Transaction Code": item.transactionCode,
                        "Payment Item Status": item.statusString,
                        "Transsferred to": item.transferUserData
                    });
                });
                var ws = XLSX.utils.json_to_sheet(sheetData);
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Payments");
                var total = this.pagination.total;
                if (total > 10000) total = 10000;
                XLSX.writeFile(wb, "Payments (" + total + ")" + this.createDateRangeText(this.params.dateFrom, this.params.dateTo) + ".xlsx");
            }
        },
        createDateRangeText(dateFrom, dateTo) {
            var result = ''
            if (dateFrom) {
                result = " from " + dateFrom.yyyymmdd();
            }
            if (dateTo) {
                if (dateFrom && dateTo.getDay() == dateFrom.getDay() && dateFrom.getMonth() == dateTo.getMonth() && dateFrom.getFullYear() == dateTo.getFullYear()) {
                    result = " on " + dateTo.yyyymmdd();
                }
                else {
                    result = result + " until " + dateTo.yyyymmdd();
                }
            }
            if (!result) {
                result = result + ' until' + new Date().yyyymmdd()
            }
            return result;
        },
        countDecimals(value) {
            if (isNaN(value)) return 0;

            value = Number(value);

            if (Math.floor(value) === value) {
                return 0;
            } else {
                return (value + '').split(".")[1].length || 0;
            }
        },
        isValidRefundAmount() {
            return !(this.availableForRefund < this.processRefundAmount || this.processRefundAmount <= 0 || this.countDecimals(this.processRefundAmount) > 2)
        },
        processRefundConfirmed() {
            var self = this;
            if (!self.isValidRefundAmount()) {
                self.$notify({ message: "Refund amount can't be less than zero or more then amount of original transaction. Allowed only 2 decimals in number.", type: 'danger', timeout: 30000 });
                return;
            }

            var params = self.getQueryStringForArray(self.selectedPaymentListIDs, "paymentIds");
            params = params + "&refundAmount=" + self.processRefundAmount + "&refundReason=" + self.processRefundReason + "&skipPaymentModule=" + self.skipPaymentModule.toString();

            self.isProcessRefundStarted = true;
            svc.processRefund(params)
                .then((resp) => {
                    var allData = resp.body;
                    if (!allData) {
                        self.$notify({ message: 'Errors occured', timeout: 60000, type: 'danger' });
                        return;
                    }

                    self.processRefundsErrors = allData.results;
                    if (!allData.isSuccess) {
                        if (allData.message == "You are not logged in!") {
                            self.$notify({ message: 'You are not logged in!', type: 'warning', timeout: 60000 });
                            window.location.href = process.env.url.manegementLogin;
                        }
                        else {
                            self.$notify({ message: 'Refund was processed with errors', type: 'warning', timeout: 60000 });
                        }
                    }
                    else {
                        self.$notify({ message: 'Refund was processed and successfully saved', type: 'success' });
                        self.processRefundAmount = null;
                    }

                    self.isProcessRefundStarted = false;
                    EventBus.$emit("admin_load_refunds");

                },
                    (resp) => {
                        self.$notify({ message: 'Something went wrong, please contact with dev team: ' + resp.body, timeout: 60000, type: 'danger' });
                        self.isProcessRefundMode = false;
                        self.isProcessRefundStarted = false;
                    });
        },
        getQueryStringForArray(array, parameterName) {
            var query = '?';
            array.forEach(id => {
                query = query + parameterName + "=" + id + "&";
            });
            return query;
        },
        processRefund() {
            var self = this;
            if (self.selectedPaymentListIDs.length < 1) {
                self.$notify({ message: 'Something went wrong. Process payment is not available, please reload page, if it not helped - contact with dev team', type: 'danger' });
                return;
            }

            self.processRefundsErrors = [];
            self.processRefundsPayments = [];
            self.availableForRefund = 0;
            self.isRefundClicked = true;

            var query = self.getQueryStringForArray(self.selectedPaymentListIDs, "paymentIds");
            svc.getRefundInformation(query)
                .then((resp) => {
                    var allData = resp.body;

                    if (allData && allData.isSuccess) {
                        self.availableForRefund = allData.availableForRefund;

                        self.processRefundItemName = allData.refundItems[0]
                            .paymentItem
                            .itemName;

                        self.refundPolicy = allData.refundItems[0]
                            .paymentItem
                            .refundPolicy;

                        if (allData.refundItems[0].paymentItem.refundPolicyLog) {
                            self.refundPolicyLog = allData.refundItems[0]
                                .paymentItem
                                .refundPolicyLog;
                        }
                        else {
                            self.refundPolicyLog = [];
                        }

                        self.processRefundsPayments = allData.refundItems;

                        self.processRefundsPayments.forEach(item => {
                            item.paymentMainData = self.tableData
                                .filter(payment => { return payment.tiPaymentId == item.tiPaymentId; })[0];
                        });

                        self.isProcessRefundMode = true;
                    }
                    else {
                        self.$notify({ message: 'Something went wrong, please contact with dev team: data is missed', timeout: 60000, type: 'danger' });
                        self.isProcessRefundMode = false;
                    }

                    self.isRefundClicked = false;
                    setTimeout(() => { window.scrollTo({ top: 200, behavior: "smooth" }); }, 0);
                },
                    () => {
                        self.isProcessRefundMode = false;
                        self.isRefundClicked = false;
                        self.$notify({ message: 'Something went wrong, please contact with dev team: data is missed', timeout: 60000, type: 'danger' });
                        setTimeout(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, 0);
                    });
        },
        cancelProcessRefund() {
            this.isProcessRefundMode = false;
            this.processRefundsErrors = [];
            this.processCancelErrors = [];
        },
        updateYearSelect() {
            this.yearSelect = [];
            var lastYear = this.currentYear;
            if (this.isAnyPaymentForNextYear) {
                lastYear++;
            }

            if (lastYear > 2009) {
                while (lastYear > 2009) {
                    this.yearSelect.push(lastYear);
                    lastYear--;
                }
            } else {
                this.yearSelect.push(2009);
            }
        },
        setInitialParams() {
            Date.prototype.yyyymmdd = function () {
                var mm = this.getMonth() + 1; // getMonth() is zero-based
                var dd = this.getDate();
                return [this.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
            };
        },
        viewTransaction(paymentId) {
            EventBus.$emit("admin_view_transaction", paymentId);
        },
        processCancelSwitch() {
            this.isProcessCancelStarted = !this.isProcessCancelStarted;
        },
        processCancelConfirmed() {
            var self = this;
            self.processCancelSwitch();

            let params = self.getQueryStringForArray(self.selectedPaymentListIDs, "paymentIds") +
                "&isCancelled=" + (self.cancelProcessStatusName == "Cancel") +
                "&isFreeRace=" + self.isIncludeFreeRaces;

            self.isProcessCancelConfirmed = true;
            svc.changeRegistrationAndPaymentStatus(params)
                .then((resp) => {
                    self.isProcessCancelConfirmed = false;

                    var allData = resp.body;
                    if (!allData) {
                        self.$notify({ message: 'Errors occured', timeout: 60000, type: 'danger' });
                        return;
                    }
                    if (allData.isAllFalse) {
                        self.$notify({ message: self.cancelProcessStatusName + ' has failed', type: 'danger', timeout: 60000 });
                    }
                    else
                        if (!allData.isSuccess) {
                            if (allData.message == "You are not logged in!") {
                                self.$notify({ message: 'You are not logged in!', type: 'warning', timeout: 60000 });
                                window.location.href = process.env.url.manegementLogin;
                            } else {
                                self.$notify({ message: self.cancelProcessStatusName + ' was processed with errors', type: 'warning', timeout: 60000 });
                            }
                        }
                        else {
                            self.$notify({ message: self.cancelProcessStatusName + ' was processed successfully', type: 'success' });
                        }

                    self.processCancelErrors = allData.results;
                },
                    (resp) => {
                        self.$notify({ message: 'Something went wrong, please contact with dev team: ' + resp.body, timeout: 60000, type: 'danger' });
                        self.isProcessCancelConfirmed = false;
                    })
                .then(() => {
                    var params = self.getParams();
                    self.loadData(params);
                });
        }
    },
    created() {
        this.setInitialParams();
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/payments/payments-tab/payments-tab.js